import { isEmptyObject } from '@travel/utils';

import { lineBreak } from './allowedTags';

import { getDictionary } from './context';
import { Dictionary, TranslateProps } from './types';

function looseJsonParse(bool: string) {
  // eslint-disable-next-line no-new-func
  return Function('"use strict";return (' + bool + ')')();
}

export const useTranslate = (props: TranslateProps) => {
  return getTranslation(props).join('');
};

export const getTranslation = (props: TranslateProps, storedDictionary?: Dictionary) => {
  const dictionary =
    storedDictionary && !isEmptyObject(storedDictionary) ? storedDictionary : getDictionary();
  const labelValue = getLabel(dictionary, props);
  if (labelValue) {
    const parts = checkAndSplitDataString(labelValue);
    return parts.map((value, index) => {
      if (index % 2 === 1) {
        const valueLowerCase = value.toLowerCase();
        return props.data && typeof props.data[valueLowerCase] !== 'undefined'
          ? props.data[valueLowerCase]
          : `{{${value}}}`;
      }
      if (value.includes('\\n')) {
        return lineBreak(value);
      }
      return value;
    });
  }
  return [];
};

export const getLabel = (
  dictionary: Dictionary,
  { id, condition, count, exist }: TranslateProps,
) => {
  if (!dictionary) return '';
  const selected = dictionary[id];
  if (!selected) return '';
  let index = 0;
  if (condition) {
    index = selected.findIndex(
      selectedCondition => selectedCondition.condition === condition(selected),
    );

    if (index === -1) return '';
  } else if (count !== undefined && count !== null) {
    const value = selected
      .filter(selectedCondition => {
        if (selectedCondition.condition.includes('count')) {
          const replaced = selectedCondition.condition.replace('count', count.toString());
          return looseJsonParse(replaced);
        }
        return false;
      })
      .map(condition => {
        if (!condition.labelValues) return '';
        return condition.labelValues[0].value;
      });
    return value[0];
  } else if (exist !== undefined) {
    const value = selected
      .filter(selectedCondition => {
        if (selectedCondition.condition.includes('exist')) {
          const replaced = selectedCondition.condition.replace('exist', exist.toString());
          return looseJsonParse(replaced);
        }
        return false;
      })
      .map(condition => {
        if (!condition.labelValues) return '';
        return condition.labelValues[0].value;
      });
    return value[0];
  }

  if (!selected[index].labelValues) return '';
  return selected[index].labelValues[0].value;
};

const checkAndSplitDataString = (value: string) => {
  return value.includes('{{') ? value.split(/{{([^}]+)}}/g) : value.split(/{([^}]+)}/g);
};
